mutation FinishStream($contentId: ID!) {
  finishStream(contentId: $contentId) {
    id
    stream {
      id
      status
    }
  }
}
